import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-table-no-data",
  "use": "icon-table-no-data-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-table-no-data\">\n<path d=\"M24.1667 5.41667H35C35.6833 5.41667 36.25 5.98334 36.25 6.66667V30C36.25 32.5333 34.2 34.5833 31.6667 34.5833H8.33333C5.8 34.5833 3.75 32.5333 3.75 30V6.66667C3.75 5.98334 4.31667 5.41667 5 5.41667H15.8333V22.0333C15.8333 22.5 16.2 22.8667 16.6667 22.8667H23.3333C23.8 22.8667 24.1667 22.5 24.1667 22.0333V5.41667Z\" fill=\"currentColor\" />\n<path d=\"M17.5 5.41667H22.5V21.2H17.5V5.41667Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol